var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"value":_vm.selected_connection,"items":_vm.connections,"item-value":"code","item-text":"description","label":_vm.label,"dense":_vm.isDense,"clearable":false},on:{"change":_vm.updateData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }